function waitFactory(ms) {
  function wait(_ref) {
    var path = _ref.path;
    return new Promise(function (resolve) {
      setTimeout(function () {
        return resolve(path ? path.continue() : null);
      }, ms);
    });
  }
  wait.displayName = 'wait - ' + ms + 'ms';
  return wait;
}
export default waitFactory;